import Highcharts, { TooltipFormatterContextObject } from 'highcharts'

import { COLORS } from './colors'

export interface BasePoint {
  ModalComponent?: ({ isOpen }: { [key: string]: any; isOpen: boolean }) => JSX.Element
  id: string
  parent: string
  value?: number
}

const formatData = (data: BasePoint[]) =>
  data.reduce((acc, point) => {
    if (point.parent === '0') {
      const clone: any = { ...point }
      clone.color = Array.from(COLORS.keys())[acc.length]
      acc.push(clone)
    } else {
      const parent = acc.find(accPoint => accPoint.id === point.parent)
      const clone: any = { ...point }
      clone.color = COLORS.get(parent.color).subColor
      acc.push(clone)
    }
    return acc
  }, [])

export interface ChartOptionsProps<Point extends BasePoint> {
  allowTooltipOutside?: boolean
  data: Point[]
  seriesName: string
  tooltipFormatter: (that: TooltipFormatterContextObject) => string
}

export const getChartOptions = <Point extends BasePoint>({
  allowTooltipOutside = true,
  data,
  seriesName,
  tooltipFormatter
}: ChartOptionsProps<Point>): Highcharts.Options => {
  const splitData = data.reduce(
    (acc, point) => {
      if (point.parent === '0') {
        acc.inner.push(point)
      } else {
        acc.outer.push(point)
      }
      return acc
    },
    { inner: [], outer: [] }
  )
  const showOnlyInnerRing = splitData.outer.length > 10 || splitData.outer.length === 0
  const filteredData = data

  const levels = showOnlyInnerRing
    ? [
        {
          level: 1,
          levelSize: {
            unit: 'pixels',
            value: 50
          }
        },
        { level: 3, levelSize: { unit: 'pixels', value: 0 } }
      ]
    : [
        {
          level: 1,
          levelSize: {
            unit: 'pixels',
            value: 20
          }
        }
      ]

  return {
    chart: {
      margin: 0,
      borderWidth: 0,
      plotBorderWidth: 0,
      plotShadow: false,
      spacing: [0, 0, 0, 0],
      backgroundColor: 'none',
      borderColor: 'none',
      width: 190,
      height: 190
    },
    title: {
      text: undefined
    },
    tooltip: {
      enabled: true,
      animation: false,
      backgroundColor: 'var(--White)',
      borderColor: 'var(--White20)',
      borderRadius: 8,
      borderWidth: 2,
      padding: 12,
      shape: 'square',
      shadow: false,
      outside: allowTooltipOutside,
      className: 'sunburst-chart-tooltip-wrapper',
      formatter() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const that = this
        return tooltipFormatter(that)
      },
      useHTML: true
    },
    plotOptions: {
      sunburst: {
        dataLabels: {
          enabled: false
        },
        showInLegend: true,
        borderWidth: 2,
        borderColor: '#fff',
        animation: {
          duration: 0
        },
        states: {
          hover: {
            enabled: true,
            brightness: 0.01,
            animation: {
              duration: 0
            }
          }
        }
      }
    },
    yAxis: {
      visible: false
    },
    xAxis: {
      visible: false
    },
    legend: {
      enabled: false
    },
    series: [
      {
        name: seriesName,
        type: 'sunburst',
        dataLabels: {
          enabled: false
        },
        data: [
          {
            id: '0',
            name: ' '
          },
          ...formatData(filteredData)
        ],
        levels
      }
    ]
  }
}
